import GoToEventCard from 'Components/Card/Variants/Card.GoToEventCard';

function FacilitatedStudyGroupCard(props) {
    return GoToEventCard(props);
}

export default FacilitatedStudyGroupCard;